import { MIMIR_TENANT_ID_CLAIM } from '@mimir/common/util/constants';

/**
 * Gets tenantId from Jwt. Looks for the new key at first then falls back to old key
 * @param jwtPayload { Payload/Claims in the jwt token}
 */
export const getTenantIdFromJwt = (jwtPayload: {[key: string]: any}) => {
  return jwtPayload[MIMIR_TENANT_ID_CLAIM] || jwtPayload['custom:tenant_id'];
};
